import module from '@babel/generator/lib/index.js';
          export default module.default ?? module;
          export * from '@babel/generator/lib/index.js';